import React, { useState } from "react";
import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { SignInForm } from "../pages/auth/forms/SignInForm";
import { SherbetLogo } from "../../styles/images/svg/SherbetLogo";
import Grid from "@mui/material/Grid";
import { AuthWrapper } from "../_uiComponents/common/AuthWrapper";

export default function Application(props) {
     return (
          <>
               <AuthWrapper heading="Login">
                    <SignInForm />
               </AuthWrapper>
          </>
     );
}
